import types from "./types";

export function updateColaboradores(colaboradores) {
    return {
        type: types.UPDATE_COLABORADORES,
        colaboradores
    };
}

export function updateComponent(component) {
    return {
        type: types.UPDATE_COMPONENT,
        component
    };
}

export function fetchColaboradores() {
    return {
        type: types.FETCH_COLABORADORES
    };
}
